import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import { ajaxPost } from '../ajax'

function StripeTerminalModal({terminal, reader, currency, amount, appFee, location, onClose, onPayment}) {
  const [error, setError] = useState(null)
  const collecting = useRef(false)
  const cancelled = useRef(false)

  useEffect(() => {
    if (reader) chargeReader()
    return () => { if (reader) cancelCharge() }
  }, [reader])

  const fetchPaymentIntent = async () => {
    const params = {
      currency: currency,
      amount: amount.toFixed(2),
      app_fee: appFee.toFixed(2),
      location_id: location,
      terminal: true
    }
    const response = await ajaxPost('/admins/payment/create_intent', params)
    const json = await response.json()
    return json.intent    
  }

  const chargeReader = async () => {
    const intent = await fetchPaymentIntent()
    if (cancelled.current) return
    if (intent.error) {
      setError(intent.error)
      return
    }
    collecting.current = true

    if (intent.secret == 'pi_test_valid') {
      return onPayment({type: 'card_number', token: 'pi_test_valid'})
    }

    const paymentMethodResult = await terminal.collectPaymentMethod(intent.secret)
    collecting.current = false
    if (cancelled.current) return
    if (paymentMethodResult.error) {
      setError(paymentMethodResult.error.message)
      return
    }
    const paymentResult = await terminal.processPayment(paymentMethodResult.paymentIntent)
    if (!cancelled.current && paymentResult.error) {
      setError(paymentResult.error.message)
      return
    }
    onPayment({type: 'card_number', token: paymentResult.paymentIntent.id})
  }

  const cancelCharge = () => {
    collecting.current && terminal.cancelCollectPaymentMethod()
    cancelled.current = true
  }

  return (
    <ReactModal isOpen={true} onRequestClose={onClose}>
      <div className='stripe-reader-payment'>
        { error && <label className='stripe-error'>{error}</label> }
        { reader && !error && <div className='animated-spinner'></div> }
        { !reader && <h3>No reader connected</h3> }
      </div>
    </ReactModal>
  )
}

StripeTerminalModal.propTypes = {
  terminal: PropTypes.object.isRequired,
  reader: PropTypes.object,
  amount: PropTypes.number.isRequired,
  appFee: PropTypes.number.isRequired,
  location: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onPayment: PropTypes.func.isRequired
}

export default StripeTerminalModal

